import { Input } from "antd";
import { ReactComponent as SearchOutlined } from "../../../common/images/svg/SearchOutline.svg";
import "./searchCustom.css";

interface SearchCustomProps {
  placeholder?: string;
  onChange?: (value: string) => void;
  onSubmit?: (value: string) => void;
  value?: string;
  className?: string;
}

export const SearchCustom: React.FC<SearchCustomProps> = ({
  placeholder,
  onChange,
  onSubmit,
  value = "",
  className = undefined,
}) => {
  return (
    <div className={`search-input-container ${className}`}>
      <Input
        value={value}
        placeholder={placeholder}
        suffix={<SearchOutlined />}
        onChange={(e) => onChange?.(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onSubmit?.(e.currentTarget.value);
          }
        }}
      />
    </div>
  );
};
